import { stats } from "@/mocks/data";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="relative flex min-h-[560px] w-full items-center overflow-hidden bg-foreground-950 md:min-h-[640px]">
        <img
          src="https://readdy.ai/api/search-image?query=%E7%BA%A2%E8%89%B2%E4%B8%8E%E6%B7%B1%E8%93%9D%E9%BB%91%E8%89%B2%E7%9A%84%E6%9C%89%E5%8A%A8%E6%84%9F%E6%8A%BD%E8%B1%A1%E7%BC%96%E8%BE%91%E8%83%8C%E6%99%AF%EF%BC%8C%E6%9D%82%E5%BF%97%E5%B0%81%E9%9D%A2%E9%A3%8E%E6%B5%81%E7%BA%BF%E5%9E%8B%E5%85%83%E7%B4%A0%E4%B8%8E%E5%87%A0%E4%BD%95%E5%BD%A2%E6%80%81%EF%BC%8C%E5%AF%B9%E8%A7%92%E7%BA%BF%E4%B8%8E%E5%9C%86%E5%BD%A2%E4%BA%A4%E9%94%99%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%8A%BD%E8%B1%A1%EF%BC%8C%E9%AB%98%E5%AF%B9%E6%AF%94%EF%BC%8C%E4%B8%93%E4%B8%9A%E8%A7%86%E8%A7%89%E8%AE%BE%E8%AE%A1&width=1800&height=1000&seq=hero-2026-b1&orientation=landscape"
          alt="反差雷达红色与深色编辑风抽象背景"
          className="absolute inset-0 h-full w-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-foreground-950/60 to-foreground-950" />

        <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6 py-16 md:py-20">
          <div className="rise-in flex max-w-3xl flex-col items-start gap-5">
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-400/50 bg-primary-500/20 px-3 py-1.5 text-xs font-semibold text-primary-100">
              <i className="ri-fire-line text-sm" />
              反差现象观察 · 全时更新
            </span>
            <h1 className="font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
              看见台前幕后的
              <span className="text-primary-400">另一面</span>
            </h1>
            <p className="max-w-2xl text-base leading-relaxed text-foreground-100 md:text-lg">
              反差雷达集中盘点反差爆料聊天记录、微信截图与私聊对话背后的来龙去脉。人设、校园、职场、情感、网络与兴趣圈子，
              凡是「公开与私下判若两人」的现象，我们都帮你捋清时间线、还原前因后果。
            </p>

            <div className="mt-2 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#feed"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                立即围观新鲜盘点
                <i className="ri-arrow-down-line ml-1.5 text-base" />
              </a>
              <a
                href="#topics"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-200/60 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
              >
                浏览反差分类
              </a>
            </div>

            <dl className="mt-6 grid w-full max-w-2xl grid-cols-2 gap-x-6 gap-y-5 border-t border-background-200/20 pt-5 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label} className="flex flex-col">
                  <dd className="order-first font-heading text-2xl font-black text-accent-300">{s.num}</dd>
                  <dt className="order-last mt-1 text-xs text-foreground-200">{s.label}</dt>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}